<template>
  <div
    role="navigation"
    class="tabs-container container-fluid navbar-expand"
  >
    <ul class="navbar-nav">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="nav-item"
      >
        <a
          href="#"
          :data-name="item.name"
          :data-test="item.name"
          class="nav-link"
          :class="{ active: item.isActive }"
          @click.prevent="changeSelectedItem(item, index)"
        >
          <span>{{ item.text }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  const modelValue = defineModel<Object>('modelValue');

  const props = defineProps<{
    items: [];
  }>();

  function changeSelectedItem(item, index) {
    props.items.forEach((tabItem, i) => {
      tabItem.isActive = i === index;
    });

    modelValue.value = item;
  }
</script>